export default __webpack_public_path__ + "static/media/Maithili_df_1.e745a9f0.mp3";